import React, { useEffect, useState } from "react";
import { getImageUrl, getProfileImageUrl } from "helpers/Image.helper";
import LoadingComponent from "commons/loading/Loading.component";
import { getCurrentLangName, getFlagByCountryCode, getStudentName } from "helpers/String.helper";
import { formatTimeAgo } from "helpers/Datetime.helper";
import * as ListApi from "api/school/v2/student/list.api";
import { IStudentListParams } from "api/school/v2/student/list.api";
import StudentInfoPopup from "../../popup/StudentInfoPopup";
import { usePopup } from "contexts/PopupContext";

const Index = () => {
    const { showPopup } = usePopup();
    const [list, setList] = useState<IStudentListParams['studentList']>([]);
    const [isInit, setIsInit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchStudentList();
    }, []);

    const fetchStudentList = async () => {
        setIsLoading(true);
        try {
            const response = await ListApi.getStudentList();
            console.log("학생 목록 응답:", response); // 디버깅용
            if (response?.studentList) {
                setList(response.studentList);
                setIsInit(true);
            }
        } catch (error) {
            console.error("학생 목록 조회 실패:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const onShowStudentInfo = (student: any) => {
        showPopup(
            <StudentInfoPopup
                info={student}
                isLoading={false}
                onClose={() => {
                    // 팝업이 닫힐 때 필요한 로직이 있다면 여기에 추가
                }}
                onExpel={(studentId: number) => {
                    // 퇴원처리 로직
                    console.log("퇴원처리:", studentId);
                    // TODO: API 호출하여 퇴원처리
                    // 확인 후 팝업 닫기
                    if (window.confirm("정말로 이 학생을 퇴원처리하시겠습니까?")) {
                        // 퇴원처리 API 호출
                        console.log("퇴원처리 확인됨:", studentId);
                        // TODO: 실제 퇴원처리 API 호출
                    }
                }}
            />
        );
    };

    // 데이터가 로드되었는지 확인
    console.log("현재 리스트 상태:", list);
    console.log("초기화 상태:", isInit);

    return (
        <main className="bg-gray-50 min-h-screen overflow-y-auto">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6">
                <h1 className="text-3xl font-bold text-gray-900 mb-6">
                    학원 소속 학생 목록
                </h1>
                <p className="text-gray-500 mb-6">
                    학원에 소속된 학생들을 확인할 수 있는 페이지입니다. 학생의 프로필을 클릭하면 상세 정보를 확인할 수 있습니다.
                </p>
            </div>
            <div className="container mx-auto px-3 sm:px-4 lg:px-6 pt-4">
                <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                    <div className="p-4">
                        {!isInit ? (
                            <LoadingComponent />
                        ) : list?.length === 0 ? (
                            <div className="flex flex-col items-center justify-center py-6 text-gray-500">
                                <svg className="w-12 h-12 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                                </svg>
                                <p className="text-center">
                                    등록된 학생이 없습니다.
                                </p>
                            </div>
                        ) : (
                            <div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                    {list.map((student: any, idx: number) => {
                                        console.log("학생 데이터:", student); // 디버깅용
                                        return (
                                            <div
                                                key={`student-${idx}`}
                                                onClick={() => onShowStudentInfo(student)}
                                                className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg cursor-pointer">
                                                <div className="flex items-center space-x-3 flex-1">
                                                    <div className="relative w-14 h-14">
                                                        <img
                                                            src={getProfileImageUrl(student?.userStudent?.profileImage)}
                                                            alt={getStudentName(student?.userStudent)}
                                                            className="w-full h-full object-cover rounded-full bg-gray-200"
                                                            onError={(e) => {
                                                                e.currentTarget.src = '/imgs/dummy/basic-img.png';
                                                            }}
                                                        />
                                                        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 text-lg">
                                                            {getFlagByCountryCode(student?.userStudent?.countryCode)}
                                                        </span>
                                                    </div>
                                                    <div className="flex-1">
                                                        <p className="text-sm text-gray-600">
                                                            {student?.userStudent?.birthday ?
                                                                new Date().getFullYear() - new Date(student.userStudent.birthday).getFullYear() + '세' :
                                                                '나이 정보 없음'
                                                            } · {getCurrentLangName(student?.userStudent?.country?.names)}
                                                        </p>
                                                        <p className="text-base font-medium text-gray-900 truncate max-w-[200px]">
                                                            {getStudentName(student?.userStudent)}
                                                        </p>
                                                        <p className="text-xs text-gray-400">
                                                            {student?.userStudent?.lastProfileUpdatedAt ?
                                                                formatTimeAgo(student.userStudent.lastProfileUpdatedAt) :
                                                                '업데이트 정보 없음'
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                                {student?.userStudent?.lastProfileUpdatedAt && (
                                                    <div className="w-3 h-3 rounded-full bg-[#CF3688] animate-pulse ml-2"></div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>

                                {isLoading && (
                                    <LoadingComponent />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Index;
